import { render } from "./ProfileNavbar.vue?vue&type=template&id=701d5e7a"
import script from "./ProfileNavbar.vue?vue&type=script&lang=js"
export * from "./ProfileNavbar.vue?vue&type=script&lang=js"

import "./ProfileNavbar.vue?vue&type=style&index=0&id=701d5e7a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__